module.exports = __webpack_public_path__ + "img/neurocognitive-mechanisms-cover.6cbdcd03.jpg";